import React from "react";
import { useAuth0 } from "./react-auth0-wrapper";

const Can = ({ roles, yes, no }) => {
  const { user, isAuthenticated, activeTenant } = useAuth0();
  const isInRole = user ? user.isInRole(roles, activeTenant) : false;

  return isAuthenticated && isInRole ? yes() : no();
};
export default Can;

export const canUserSave = (roles) => {
  const { user, activeTenant } = useAuth0();
  const canSave = user ? user.isInRole(roles, activeTenant) : false;
  return canSave;
};
